let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvhuG")).then(() => parcelRequire('bG0Vp'));